import Select from "react-select";
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label:  "Não se aplica" },
    { value: 2, label:  "Posto de transformação" },
    { value: 3, label:  "Cabine" },
    { value: 4, label:  "Subestação" }
];

const TipoInstalacao = ({ field, placeholder, name, id, disabled=false, onKeyDown, className="" }) => {
    return (
        <Select 
            options={options}
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
            onKeyDown={onKeyDown}
            className={className}
        />
    )
}

export { TipoInstalacao, options as OpcoesTipoInstalacao }